import React from "react";
import PropTypes from "prop-types";
import { parse } from "qs";

import { STREAM_TYPE, DEFAULT_CARD_HEIGHT } from "config/constants";
import Stream from "stream/containers/Stream";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import LatestStories from "components/Library/LatestStories";
import PermalinkCard from "cards/containers/PermalinkCard";
import PermalinkStreamHelmet from "stream/components/PermalinkStreamHelmet";
import Preview from "stream/containers/Preview/Preview";

class PermalinkStream extends React.Component {
  render() {
    const parsedQs = parse(this.props.location.search.slice(1));
    const isPreview = !!parsedQs.preview;

    return (
      <React.Fragment>
        <StandardLayout
          main={
            isPreview ? (
              <Preview
                permalinkId={this.props.match.params.id}
                revision={parsedQs.revision}
              />
            ) : (
              <React.Fragment>
                <PermalinkStreamHelmet id={this.props.match.params.id} />
                <Stream
                  type={STREAM_TYPE.PERMALINK}
                  lookup={this.props.match.params.id}
                  streamOverride={parsedQs.stream}
                  onlyShowTitleForA11y={true}
                  defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
                  contentComponent={PermalinkCard}
                  serverRenderedNodeCount={1}
                  trackFirstItem={true}
                />
              </React.Fragment>
            )
          }
          complementary={<LatestStories />}
          mainAriaLabel="Stories"
        />
      </React.Fragment>
    );
  }
}

PermalinkStream.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};

export default PermalinkStream;
